import { render, staticRenderFns } from "./PasswordResetFormItem.vue?vue&type=template&id=4df32454&"
import script from "./PasswordResetFormItem.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports